export enum AmazonServiceType {
  FBA = 1,
  FBM,
}
